import { joinStrings } from '../utils/StringUtils';

export function formatAddressLine(
  zip: null | string | undefined,
  city: null | string | undefined,
  state: null | string | undefined,
  country?: null | string,
) {
  return joinStrings(', ', city, joinStrings(' ', state, zip), country);
}

interface MakeCityStateZipProps {
  city: null | string | undefined;
  state: null | string | undefined;
  zip: null | string | undefined;
}

export function makeCityStateZip({
  city,
  state,
  zip,
}: Partial<MakeCityStateZipProps> = {}) {
  return joinStrings(', ', city, joinStrings(' ', state?.toUpperCase(), zip));
}
